export const GAME_CONFIG = {
  initialSquares: 25,
  initialCircles: 25,
  referenceArenaArea: 1200 * 700,
  minHealth: 1500,
  maxHealth: 2000,
  fixedStepMs: 1000 / 60,
  maxFrameDeltaMs: 100,
  maxCatchUpSteps: 5,
  wallThickness: 28,
  restitution: 0.78,
  friction: 0.08,
  frictionAir: 0.003,
  initialSpeed: 1.4,
  explosionPower: 170_000,
  explosionMinimumDistance: 38,
  explosionMaximumVelocityDelta: 24,
  maximumBodySpeed: 44,
  referenceBodySize: 48,
  collisionSpeedThreshold: 2.8,
  collisionDamageScale: 72,
  firstLevelBalanceTarget: 50,
  balanceTargetStep: 5,
  maximumBalanceTarget: 80,
  deathHealth: 0,
} as const

export const clamp = (value: number, min: number, max: number): number =>
  Math.min(max, Math.max(min, value))
